<template>
  <div class="smart">
    <div class="container">
      <div class="row ">
        <div class="col-md-7 img-smart">
          <img
            class="main-img"
            src="../../../assets/img/sessions/Smart-Rooms.png"
            alt=""
          />
        </div>
        <div class="col-md-5 text-smart">
          <h2>SMART</h2>
          <p>
            We have gone beyond Screen Sharing to provide you with cutting edge
            AI collaborative tools covering the areas of Debt Solutions,
            Corporate Financing, Real Estate, Personal Financial Planning/
            Budgeting and Investment Banking
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sessions_Smart",
  created() {}
};
</script>

<style lang="scss" scoped>
.smart {
  .img-smart {
    min-height: 452px;
    display: flex;
    align-items: center;
    position: relative;
    .main-img {
      width: 120%;
      max-width: 120%;
      margin-left: -56px;
    }
  }
  .text-smart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 15%;
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #474d52;
      margin-bottom: 5px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
    }
  }
}
</style>
